import React, { FC, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'
import FhirLoader from '../../../components/FhirLoader'
import { Link } from 'react-router-dom'
import useAccounts from '../../../hooks/admin/useAccounts'
import isAuthenticated from '../../../routes/PrivateRoute'
import useUserWithRole from '../../../hooks/authentication/useUserWithRole'
import PermissionGate from '../../../components/PermissionGate'
import Identifier from '../../../components/FhirData/DataTypes/Identifier'
import PageTitle from '../../../components/PageTitle'
import { formatDateTime } from '../../../utils/helpers'

const Users: FC = () => {
  const [accountStatus, setAccountStatus] = useState('all')

  const { data: accounts, isLoading, isSuccess, isRefetching } = useAccounts()

  const { user } = useUserWithRole()


  const updateAccountFilter = (event: any) => {
    setAccountStatus(event.target.value)
  }

  const filterAccounts = (accounts: any) => {
    return accounts.filter((account: any) => {
      if (accountStatus === 'active') return account.enabled
      if (accountStatus === 'locked') return !account.enabled
      return account
    })
  }

  return (
    <section>
      <PermissionGate
        user={user}
        role='admin'
      >
        <Container  >
          <PageTitle displayName="Member Accounts" />
          <h1 className='headerText h2'>Member Accounts</h1>
          {(isLoading || isRefetching) ? (
            <FhirLoader message="Loading..." />
          ) : (
          <Table size='sm' hover className='border-top'>
            <thead>
              <tr>
                <th scope='col'>&nbsp;</th>
                <th scope='col'>
                  &nbsp;
                </th>
                <th scope='col'>
                  <Form.Select
                    as='select'
                    name='accountStatus'
                    value={accountStatus}
                    onChange={updateAccountFilter}
                  >
                    <option value='all'>All</option>
                    <option value='active'>Active</option>
                    <option value='locked'>Locked</option>
                  </Form.Select>
                </th>
                <th scope='col' colSpan={4}>&nbsp;</th>
              </tr>
              <tr>
                <th scope="col">Member Name</th>
                <th scope="col">Patient Identifier</th>
                <th scope="col">Account Status</th>
                <th scope="col">Details</th>
                <th scope='col'>Proxy</th>
                <th scope='col'>Proxy Name</th>
                <th scope='col'>Last Login</th>
              </tr>
            </thead>
            <tbody>
              {
                !(isLoading || isRefetching) && isSuccess && accounts.accounts.length > 0 && (
                  <>
                    {
                      filterAccounts(accounts.accounts).map((account: any) => (
                        <tr key={account.id}>
                          <td>
                            {account.firstName} {account.lastName}
                          </td>
                          <td>
                            <Identifier data={account.attributes.memberId} />
                          </td>
                          <td>
                            {
                              account.enabled ? 'Active' : 'Locked'
                            }
                          </td>
                          <td>
                            <Link to={`/account/${account.id}`}>Details</Link>
                          </td>
                          <td>
                            {
                              account.isProxy ? 'Y' : ''
                            }
                          </td>
                          <td>
                            {account.proxyFirstName} {account.proxyLastName}
                          </td>
                          <td>
                            {
                              formatDateTime(account.lastLoginDate)
                            }
                          </td>
                        </tr>
                      ))
                    }
                  </>
                )
              }
              {
                !(isLoading || isRefetching) && isSuccess && accounts.accounts.length === 0 && (
                  <tr>
                    <td scope="row" colSpan={8} className='text-center' style={{ backgroundColor: '#e3e3e3' }}>
                      <span>No Data found!</span>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </Table>
          )}
        </Container>
      </PermissionGate>

    </section>
  )
}

export default isAuthenticated(Users)